import { useEffect, useState } from 'react';

const useScrollPosition = (scrollContainer: HTMLElement | null) => {
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);

  useEffect(() => {
    const handleIsScrollable = () => {
      if (!scrollContainer) return;
      const { scrollLeft, scrollWidth } = scrollContainer;
      setShowLeft(scrollLeft > 0);
      setShowRight(scrollLeft + scrollContainer.getBoundingClientRect().width < scrollWidth - 1); // -1 pour marge d'erreur
    };

    handleIsScrollable(); // appel initial
    scrollContainer?.addEventListener('scroll', handleIsScrollable);

    return () => {
      scrollContainer?.removeEventListener('scroll', handleIsScrollable);
    };
  }, [scrollContainer]);

  return { showLeft, showRight };
};

export default useScrollPosition;
